// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PIM_REQUEST = 'FETCH_PIM_REQUEST';
export const FETCH_PIM_SUCCESS = 'FETCH_PIM_SUCCESS';
export const FETCH_PIM_FAILURE = 'FETCH_PIM_FAILURE';

export const FETCH_PENDING_PIM_REQUEST = 'FETCH_PENDING_PIM_REQUEST';
export const FETCH_PENDING_PIM_SUCCESS = 'FETCH_PENDING_PIM_SUCCESS';
export const FETCH_PENDING_PIM_FAILURE = 'FETCH_PENDING_PIM_FAILURE';

export const FETCH_PO_DC_PIM_REQUEST = 'FETCH_PO_DC_PIM_REQUEST';
export const FETCH_PO_DC_PIM_SUCCESS = 'FETCH_PO_DC_PIM_SUCCESS';
export const FETCH_PO_DC_PIM_FAILURE = 'FETCH_PO_DC_PIM_FAILURE';

export const FETCH_PIM_SUPPLIER_REQUEST = 'FETCH_PIM_SUPPLIER_REQUEST';
export const FETCH_PIM_SUPPLIER_SUCCESS = 'FETCH_PIM_SUPPLIER_SUCCESS';
export const FETCH_PIM_SUPPLIER_FAILURE = 'FETCH_PIM_SUPPLIER_FAILURE';

export const FETCH_PIM_PROGRAM_REQUEST = 'FETCH_PIM_PROGRAM_REQUEST';
export const FETCH_PIM_PROGRAM_SUCCESS = 'FETCH_PIM_PROGRAM_SUCCESS';
export const FETCH_PIM_PROGRAM_FAILURE = 'FETCH_PIM_PROGRAM_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_PIM_REQUEST = 'CREATE_PIM_REQUEST';
export const CREATE_PIM_SUCCESS = 'CREATE_PIM_SUCCESS';
export const CREATE_PIM_FAILURE = 'CREATE_PIM_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_MULTIPLE_PIM_REQUEST = 'CREATE_MULTIPLE_PIM_REQUEST';
export const CREATE_MULTIPLE_PIM_SUCCESS = 'CREATE_MULTIPLE_PIM_SUCCESS';
export const CREATE_MULTIPLE_PIM_FAILURE = 'CREATE_MULTIPLE_PIM_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_PIM = 'CREATE_USER_FORM_PIM';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_PIM_REQUEST = 'UPDATE_PIM_REQUEST';
export const UPDATE_PIM_SUCCESS = 'UPDATE_PIM_SUCCESS';
export const UPDATE_PIM_FAILURE = 'UPDATE_PIM_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_PIM_REQUEST = 'FETCH_SINGLE_PIM_REQUEST';
export const FETCH_SINGLE_PIM_SUCCESS = 'FETCH_SINGLE_PIM_SUCCESS';
export const FETCH_SINGLE_PIM_FAILURE = 'FETCH_SINGLE_PIM_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_PIM_REQUEST = 'DELETE_PIM_REQUEST';
export const DELETE_PIM_SUCCESS = 'DELETE_PIM_SUCCESS';
export const DELETE_PIM_FAILURE = 'DELETE_PIM_FAILURE';

// USERFORM RESET

export const PIM_USERFORM_RESET = 'PIM_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_PIM_DETAILS = 'NAVIGATE_PIM_DETAILS';
export const NAVIGATE_ADDITIONAL_EXPENSE = 'NAVIGATE_ADDITIONAL_EXPENSE';
// navigate to company component
export const NAVIGATE_PIM = 'NAVIGATE_PIM';

export const RESET_FORM_DATA_WITHOUT_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_INWARD_ID_DK';
export const SET_ACTIVE_KEY_PIM_INWARD_DK = 'SET_ACTIVE_KEY_PIM_INWARD_DK';

export const FETCH__PIM_BILLS_PROGRAM_REQUEST = 'FETCH__PIM_BILLS_PROGRAM_REQUEST';

export const FETCH__PIM_BILLS_PROGRAM_SUCCESS = 'FETCH__PIM_BILLS_PROGRAM_SUCCESS';

export const FETCH__PIM_BILLS_PROGRAM_FAILURE = 'FETCH__PIM_BILLS_PROGRAM_FAILURE';

export const FETCH__PIM_AMOUNT_POST_REQUEST = 'FETCH__PIM_AMOUNT_POST_REQUEST';
export const FETCH__PIM_AMOUNT_POST_SUCCESS = 'FETCH__PIM_AMOUNT_POST_SUCCESS';
export const FETCH__PIM_AMOUNT_POST_FAILURE = 'FETCH__PIM_AMOUNT_POST_FAILURE';
